import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import firebase from 'firebase/app';
import { Card, Skeleton } from 'antd';
import qs from 'qs';

import Redirect404 from '../../components/Redirect404';
import TrackerService from '../../utils/TrackerService';
import PoweredByStrike from '../../components/customer/PoweredByStrike';
import FooterCard from '../../components/customer/FooterCard';
import StrikeScanEventModel from '../../models/StrikeScanEventModel';
import { getLogo } from '../../utils/BrandConfig';

import '../../App.scss';
import 'antd/dist/antd.css';

export default class TagDetailScreen extends Component {

  // Properties used by this component:
  // appActions, deviceInfo, rating, countOfTips, averageRating, messageText, values, topLogo, profileBio, displayName, avatar, selectedValueByIndex, bottomLogo

  constructor(props) {
    super(props);
    
    this.state = {
      loading: true,
      loadingText: 'Loading...'
    };

    document.title = "Tag - Strikepay";
  }

  async componentDidMount () {
    this.startScan();
  }

  async getCurrentUser(auth) {
    return new Promise((resolve, reject) => {
       const unsubscribe = auth.onAuthStateChanged(user => {
          unsubscribe();
          resolve(user);
       }, reject);
    });
  }

  componentWillUnmount() {
  }

  componentDidUpdate() {
  }


  // MARK: Routing tap to proper location

  startScan = async () => {
    // Start auth and URL parsing in parallel
    const authPromise = this.getCurrentUser(firebase.auth()).then(async user => {
      if (!user || user.isAnonymous) {
        const result = await firebase.auth().signInAnonymously();
        return result.user;
      }
      return user;
    });

    const isLocalHost = window.location.hostname === 'localhost';
    const parsed = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    
    const user = await authPromise;

    const cancelled = parsed.cancelled;
    const isTest = isLocalHost || parsed.isTest;
    const uuid = parsed.uuid;

    let tagUid = null;
    let qrUid = null;
    let source = null;
    let teamMemberId = null;

    // payment link query params
    let amount = null;
    let name = null;
    let reference = null;
    let refId = null;

    let urlParameter = null;

    if (this.props.location && this.props.location.search) {
      if (parsed.uid || parsed.UID) {
        tagUid = parsed.uid || parsed.UID;
        source = "nfc";
      } else if (parsed.qr || parsed.QR) {
        qrUid = parsed.qr || parsed.QR;
        source = "qr"
      }

      if (parsed.tmid) teamMemberId = parsed.tmid;
      if (parsed.amount) amount = parseInt(parsed.amount);
      if (parsed.name) name = decodeURIComponent(parsed.name);
      if (parsed.reference) reference = decodeURIComponent(parsed.reference);
      if (parsed.refId) refId = decodeURIComponent(parsed.refId);
      if (parsed.url) urlParameter = decodeURIComponent(parsed.url);
    }

    const tagIdFromMatch = this.props.match.params.tagId;
    let tagId = tagIdFromMatch;
    if (tagIdFromMatch.includes('---')) {
      const parts = tagIdFromMatch.split('---');
      tagId = parts[0];
      if (!tagUid && !qrUid) {
        tagUid = parts[1];
        source = "nfc"; // Default source if extracted from ID
      }
    }
    
    const payloadData = {
      tagId: tagIdFromMatch,
      tagUid: tagUid || qrUid,
      source,
      uid: user.uid,
      teamMemberId,
      amount,
      name,
      reference,
      refId,
      url: urlParameter,
    }

    this.setState({
      user,
      waitingOnTagEvent: true,
      cancelled,
      isTest,
      tagId: tagIdFromMatch,
      baseTagId: tagId,
      tagUid: tagUid || qrUid,
      qrUid,
      source,
      amount: parsed.amount,
      currency: parsed.currency,
      uuid,
      templateTagId: tagId,
      url: urlParameter,
    });

    this.trackScan();

    this.waitOnTagEventUpdate(payloadData);
  }


  waitOnTagEventUpdate = async (payloadData) => {
    this.scanModel = new StrikeScanEventModel({
      ...payloadData
    });

    // 1. Generate ID and start listening IMMEDIATELY
    const scanId = this.scanModel.generateScanId();
    this.scanId = scanId;

    this.setState({
      waitingOnTagEvent: true,
      loadingText: `Waiting on server...`
    });

    this.scanModel.observeScan(this.scanId,
      (result) => {
        if (!result) return;
        
        if (result.error) {
          console.log(result.error);
          this.scanModel.stop();
          this.setState({
            waitingOnTagEvent: false,
            loadingText: `Could not resolve scan.`,
            ...result,
            loading: false,
            redirectRoute: null,
          });
        } else if(result.route) {
          this.scanModel.stop();
          this.handleTagEvent({ ...result });
        }
      }
    );

    // 2. Create the scan doc in the background/after listener is active
    await this.scanModel.createScan();
  }

  handleTagEvent = async (result) => {
    let user = this.state.user;

    let route = result.route;
    let tapId = result.tapId;
    let tagId = result.tagId || this.state.tagId;
    let clientId = result.clientId;
    let redirectUrl = result.redirectUrl;

    let tagUid = this.state.tagUid;
    let qrUid = this.state.qrUid;
    let source = this.state.source;
    let isTest = this.state.isTest;
    let urlParameter = this.state.url;

    let redirectRoute = "/404";
    let routeType = "404";

    const tracker = new TrackerService({
      tagId,
      object: this.state.tag,
      isTest,
    });

    if (route === "tap") {
      // All live tags (team and non-team) should be handled by strike-payer, not app.strikepay.co
      const hostname = window.location.hostname === 'localhost' ? 'http://localhost:8088' : 'https://pay.strikepay.co';
      
      // Use baseTagId (template ID) instead of consolidated ID for strike-payer
      const redirectTagId = result.tagId || this.state.baseTagId || this.state.tagId;
      let strikePayerUrl = new URL(`${hostname}/tags/${redirectTagId}`);
      
      // Preserve all query parameters from the original request
      if (this.props.location && this.props.location.search) {
        const parsed = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
        // Add source parameter (uid or qr)
        if (tagUid) {
          const sourceParam = (source === 'nfc') ? 'uid' : 'qr';
          strikePayerUrl.searchParams.append(sourceParam, tagUid);
        }
        // Preserve payment link parameters
        if (parsed.amount) strikePayerUrl.searchParams.append('amount', parsed.amount);
        if (parsed.name) strikePayerUrl.searchParams.append('name', parsed.name);
        if (parsed.reference) strikePayerUrl.searchParams.append('reference', parsed.reference);
        if (parsed.refId) strikePayerUrl.searchParams.append('refId', parsed.refId);
        // Preserve team member ID if present
        if (parsed.tmid) strikePayerUrl.searchParams.append('tmid', parsed.tmid);
        // Preserve signup URL if present
        if (parsed.url) strikePayerUrl.searchParams.append('url', parsed.url);
      } else if (tagUid) {
        // Fallback: if no query params but we have tagUid, add it
        const sourceParam = (source === 'nfc') ? 'uid' : 'qr';
        strikePayerUrl.searchParams.append(sourceParam, tagUid);
      }
      
      // Add queryParams from result if present (e.g., tmid from backend)
      if (result.queryParams) {
        const queryParams = new URLSearchParams(result.queryParams.substring(1)); // Remove leading '?'
        queryParams.forEach((value, key) => {
          strikePayerUrl.searchParams.append(key, value);
        });
      }
      
      redirectRoute = strikePayerUrl.toString();
      routeType = result.teamId ? "team-tag-redirect" : "live-tag-redirect";
    } else if (route === "claim") {
      let route = `/claim/${tagId}`;
      routeType = "claim";

      const queryParams = [];
      if (tagUid) {
        queryParams.push(`uid=${tagUid}`);
      } else if (qrUid) {
        queryParams.push(`qr=${qrUid}`);
      }

      if (urlParameter) {
        queryParams.push(`url=${encodeURIComponent(urlParameter)}`);
      }

      if (queryParams.length > 0) {
        route += `?${queryParams.join('&')}`;
      }

      redirectRoute = route;
    } else if (route === "client-manage") {
      redirectRoute = `/client/manage/${clientId}`;
      routeType = "client-manage";
    } else if (route === "tag-manage") {
      redirectRoute = `/client/manage/${clientId}/tags/${tagId}`;
      routeType = "tag-manage";
    } else if (route === "redirect") {
      routeType = "external-redirect";
      redirectRoute = redirectUrl;
    } else if (route === "setup") {
      redirectRoute = `/setup/${tagId}`;
      routeType = "setup-required";
    } else if (route === 'paused-404'){
      // If teamMemberId is present (from tmid query param), redirect to strike-payer anyway
      // This handles saved links/QRs with tmid parameter - let strike-payer handle paused state
      if (result.teamId || (this.props.location && this.props.location.search && qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).tmid)) {
        const hostname = window.location.hostname === 'localhost' ? 'http://localhost:8088' : 'https://pay.strikepay.co';
        let strikePayerUrl = new URL(`${hostname}/tags/${tagId}`);
        
        // Preserve all query parameters, especially tmid
        if (this.props.location && this.props.location.search) {
          const parsed = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
          if (tagUid) {
            const sourceParam = (source === 'nfc') ? 'uid' : 'qr';
            strikePayerUrl.searchParams.append(sourceParam, tagUid);
          }
          if (parsed.tmid) strikePayerUrl.searchParams.append('tmid', parsed.tmid);
          if (parsed.amount) strikePayerUrl.searchParams.append('amount', parsed.amount);
          if (parsed.name) strikePayerUrl.searchParams.append('name', parsed.name);
          if (parsed.reference) strikePayerUrl.searchParams.append('reference', parsed.reference);
          if (parsed.refId) strikePayerUrl.searchParams.append('refId', parsed.refId);
          if (parsed.url) strikePayerUrl.searchParams.append('url', parsed.url);
        }
        
        redirectRoute = strikePayerUrl.toString();
        routeType = "paused-team-redirect";
      }
      // Otherwise, paused tags without teamMemberId stay in strikepay (future: show paused message)
    }

    tracker.mixpanelTrack("tag_lookup", {
      distinct_id: user.uid,
      tagId: tagId,
      templateTagId: this.state.tagId,
      redirectType: routeType,
      isAnonymous: user.isAnonymous,
      source: this.state.source || 'none',
      tagUid: this.state.tagUid || 'none',
      url: this.state.url,
    });  

    if (!isTest) {
      tracker.googleTrack(
        "tag_lookup", 
        {
          userId: user.uid,
          tagId: tagId,
          templateTagId: this.state.tagId,
          redirectType: routeType,
          isAnonymous: user.isAnonymous,
          source: this.state.source || 'none',
          tagUid: this.state.tagUid || 'none',
          url: this.state.url,
        }
      );
    }

    if (route === "redirect") {
      const fromUrl = this.props.location ? this.props.location.pathname : null;
      tracker.mixpanelTrack("tag_redirect", {
        distinct_id: user.uid,
        tagId: tagId,
        templateTagId: this.state.tagId,
        redirectUrl: redirectUrl,
        fromUrl: fromUrl,
        isAnonymous: user.isAnonymous,
        source: this.state.source || 'none',
        tagUid: this.state.tagUid || 'none',
        url: this.state.url,
      });
      window.location.replace(redirectUrl);
      return; // Exit early to prevent state update
    }

    // Handle live tag redirects to strike-payer (external redirect)
    // All live tags (team and non-team) should be handled by strike-payer
    // Also handle paused tags with teamMemberId (from saved links/QRs)
    if (routeType === "team-tag-redirect" || routeType === "live-tag-redirect" || routeType === "paused-team-redirect") {
      const fromUrl = this.props.location ? this.props.location.pathname : null;
      tracker.mixpanelTrack("tag_redirect_to_strike_payer", {
        distinct_id: user.uid,
        tagId: tagId,
        templateTagId: this.state.tagId,
        redirectUrl: redirectRoute,
        fromUrl: fromUrl,
        routeType: routeType,
        teamId: result.teamId || null,
        teamTapBehaviour: result.teamTapBehaviour || null,
        isAnonymous: user.isAnonymous,
        source: this.state.source || 'none',
        tagUid: this.state.tagUid || 'none',
        url: this.state.url,
      });
      window.location.replace(redirectRoute);
      return; // Exit early to prevent state update
    }

    if (this.state.cancelled) {
      const checkout_tag_id = tagId;
      const checkout_total_amount = this.state.amount;
      const checkout_currency = this.state.currency;

      const { decimalAmount, decimalFee } = tracker.intValuesToDecimals({ amount: checkout_total_amount, fee: 0  });
  
      // Track all default data plus fees and amount as calculated in this method
      tracker.mixpanelTrack("checkout_cancelled", {
        distinct_id: this.state.uuid,
        currency: checkout_currency,
        tagId: checkout_tag_id,
        amount: decimalAmount,
      });  

      if (!isTest) {
        tracker.googleTrack(
          "checkout_cancelled", 
          {
            currency: checkout_currency,
            tagId: checkout_tag_id,
            value: decimalAmount,
          }
        );
      }
    }

    this.setState({
      waitingOnTagEvent: false,
      loadingText: 'Done',
      loading: false,
      redirectRoute,
    });
  }

  trackScan = async () => {
    let user = await this.getCurrentUser(firebase.auth());
    const isLocalHost = window.location.hostname === 'localhost';
    let isTest = this.state.tag ? this.state.tag.is_test : isLocalHost;    

    const tracker = new TrackerService({
      tagId: this.state.tagId,
      object: this.state.tag,
      isTest,
    });

    tracker.mixpanelTrack("tag_scan", {
      distinct_id: user.uid,
      tagId: this.state.tagId,
      isAnonymous: user.isAnonymous,
      templateTagId: this.state.templateTagId || 'generic',
      source: this.state.source || 'none',
      tagUid: this.state.tagUid || 'none',
      url: this.state.url,
    });

    if (!isTest) {
      tracker.googleTrack(
        "tag_scan",
        {
          userId: user.uid,
          tagId: this.state.tagId,
          isAnonymous: user.isAnonymous,
          templateTagId: this.state.templateTagId || 'generic',
          source: this.state.source || 'none',
          tagUid: this.state.tagUid || 'none',
          url: this.state.url,
        }
      );
    }
  }


  // MARK: render()
  renderTagSearching = () => {    
    const gridStyle = {
      width: '100%',
      textAlign: 'start',
    };

    const loadingText = this.state.loading ? (this.state.loadingText || "Loading...") : "";

    return (
      <div style={{ maxWidth: '100%', marginLeft: 'auto', marginRight: 'auto', }}>
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <img
            src={getLogo(this.props.brand || 'striketip')}
            alt="Home"
            style={{ height: 36, maxWidth: 180, objectFit: 'contain' }}
          />
        </div>

        <Card
          style={{ maxWidth: '100%', margin: 'auto' }}
        >
            <Card.Grid style={gridStyle}><Skeleton loading={true} active /></Card.Grid>
            <Card.Grid style={gridStyle}><Skeleton.Image loading={true} active /></Card.Grid>
            <Card.Grid style={gridStyle}><p style={{ fontWeight: 'bold' }}>{loadingText}</p></Card.Grid>
            <Card.Grid style={gridStyle}><Skeleton.Button loading={true} active size='large' /></Card.Grid>
        </Card>
      </div>
    );
  }


  render() {
    const { loading, redirectRoute } = this.state;

    if (!loading && redirectRoute) {
      return (<Redirect to={redirectRoute}/>);
    } else if (loading) {
      return this.renderTagSearching();
    } else {
      return <Redirect404 fromPath={this.props.location ? this.props.location.pathname : null} reason={"tag-not-found"} />
    }
  }

}
